import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { Constants } from "@/lib/constants";

import { UnderstandingLevel } from "@live-writing/models";

interface UnderstandingGroup {
  level: UnderstandingLevel;
  label: string;
  color: string;
  count: number;
}

interface UnderstandingChartProps {
  data: UnderstandingGroup[];
}

const UnderstandingChart = ({ data }: UnderstandingChartProps) => {
  const chartData = data.map((group) => ({
    name: group.label.includes(' ') ? group.label.replace(' ', '\n') : group.label,
    count: group.count,
    fill: group.color,
    level: group.level,
  }));

  const total = chartData.reduce((s, d) => s + (d.count || 0), 0);

  const CustomTooltip = ({
    active,
    payload,
    label,
  }: any & { total: number }) => {
    if (!active || !payload || !payload.length) return null;
    const value = payload[0].value as number;
    const percent = total > 0 ? Math.round((value / total) * 100) : 0;

    return (
      <div className="bg-white border border-gray-200 p-2 rounded shadow-sm text-sm">
        <div className="font-medium text-gray-700">{label}</div>
        <div className="text-muted-foreground">
          {value} students • {percent}%
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-8 w-full">
      <div className={`${Constants.CHART.HEIGHT_CLASS} w-full`}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
            barCategoryGap="10%"
          >
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              interval={0}
              tick={{ fontSize: 12, fill: '#4B5563' }}
            />
            <YAxis hide />
            <Tooltip
              content={<CustomTooltip total={total} />}
              cursor={{ fill: "rgba(0,0,0,0.04)" }}
            />
            <Bar
              dataKey="count"
              radius={[4, 4, 0, 0]}
              maxBarSize={Constants.CHART.MAX_BAR_SIZE}
            ></Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default UnderstandingChart;
